import { GoogleOAuthProvider } from "@react-oauth/google";
import Login from "./Login";
import { useSelector, useDispatch } from "react-redux";
import ErrorModal from "./ErrorModal";
import { leaderboardActions, loadStudentsActions } from "../store/leaderboard";
import { NavLink, useNavigate } from "react-router-dom";
import styles from "./Leaderboard.module.css";
import Pagination from "./Pagination";
import Announcement from "./Announcement";
import Podium from "./Podium";
export default function LeaderBoard() {
  let loginLoader = false;
  function GoogleAuthWrapper() {
    return (
      <GoogleOAuthProvider clientId="586203942024-okrtupb8i4mja23nmidi5jmkgee300ca.apps.googleusercontent.com">
        <Login loginLoader/>
      </GoogleOAuthProvider>
    );
  }
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tokenFromStorage = JSON.parse(localStorage.getItem("userData")) || null
  const {coder, toppers, showCoderState, totalPages, currentPage} = useSelector(
    (state) => state.myLeaderboard
  );
  const { loading, error, successMsg, errorMsg, status } = showCoderState;

  const {loading: loginLoading} = useSelector(state => state.myUser.loginState)

  function handleCloseErrorModal() {
    if(status === 499){dispatch(leaderboardActions.showLeaderboard({ type: "LEADERBOARD_RESET" }));
    navigate("/question");}
    else{dispatch(leaderboardActions.showLeaderboard({ type: "LEADERBOARD_RESET" }));
    navigate("/500");}
  }
  // function handleRefreshClick() {
  //   dispatch(loadStudentsActions());
  // }
  if (loading) {
    return <p className={styles.loading}>Loading....</p>;
  }

  if(loginLoading){
    return <p className={styles.loading}>Logging you in....</p>;
  }
  return (
    <div className={styles.leaderboardContainer}>
      {/* <h1 className={styles.title}>Leaderboard</h1> */}
      <div className={styles.authWrapper}>
        <GoogleAuthWrapper />
      </div>
      <Podium topThree={toppers ?? []}/>
      <div className={styles.listContainer}>
        <ErrorModal
          openModal={error}
          message={errorMsg ? errorMsg[0] : "An error occurred"}
          handleCloseModal={handleCloseErrorModal}
          block={status === 499}
        />
        {error ? null : coder && coder.length > 0 ? (
          <table className={styles.leaderboardTable}>
            <thead>
              <tr className={styles.tableHeader}>
                <th>Rank</th>
                <th>Name</th>
                <th>Email</th>
                <th>Score</th>
                <th>Relative Score</th>
                <th>Codes</th>
              </tr>
            </thead>
            <tbody>
            {coder
            .map((c, index) => (
              <tr key={c._id} className={tokenFromStorage?.token && index === 0 && styles.abc}>
                <td>{c.rank}{c.rank === 1 ? ` 🥇` : c.rank === 2 ? ` 🥈` : c.rank === 3 ? ` 🥉` : ""}</td>
                <td>{c.name}</td>
                <td>{c.email}</td>
                <td>{c.score}</td>
                <td>{c.relative ?? 0}</td>
                <td><NavLink to={`/view-code/${c._id}`}>view code</NavLink></td>
              </tr>
            ))}
            </tbody>
          </table>
        ) : (
          <p className={styles.noData}>The leaderboard will be announced soon.....</p>
        )}
      </div>
      {/* <button
        onClick={handleRefreshClick}
        className={styles.refreshButton}
        disabled={loading}
      >
        Refresh
      </button> */}
    <Pagination totalPages={totalPages}/>
    {/* <Announcement/> */}
    </div>
  );
}